import { useState } from 'react';
import { ReactSession } from 'react-client-session';

const testOnlyProducts = [
	{
		service: {
			appt_duration: '15',
			appt_stackable: 'true',
			email_template: 'testOnlyPurchase',
			enable_discount: true,
			is_private: false,
			service_bookable: true,
			service_code: 'fullBloodCountTin',
			service_id: 998,
			service_name: 'Full Blood Count (FBC)',
			tdl_lab_code: ['FBC'],
			service_price: 21000,
			service_status: 'true',
			service_type: 'Postal',
		},
	},
	{
		service: {
			appt_duration: '15',
			appt_stackable: 'true',
			email_template: 'testOnlyPurchase',
			enable_discount: true,
			is_private: false,
			service_bookable: true,
			service_code: 'HbA1cTin',
			service_id: 997,
			service_name: 'HbA1c',
			tdl_lab_code: ['GHB'],
			service_price: 20000,
			service_status: 'true',
			service_type: 'Postal',
		},
	},
	{
		service: {
			appt_duration: '15',
			appt_stackable: 'true',
			email_template: 'testOnlyPurchase',
			enable_discount: true,
			is_private: false,
			service_bookable: true,
			service_code: 'HepBAgTin',
			service_id: 996,
			service_name: 'Hep B surface Ag',
			tdl_lab_code: ['AUAG'],
			service_price: 13500,
			service_status: 'true',
			service_type: 'Postal',
		},
	},
];

const SelectTestOnly = ({ businessPartnerTests, setBookingData, onContinue }) => {
	const user = ReactSession.get('user');
	const [formData, setFormData] = useState({
		firstName: '',
		lastName: '',
		gender: '',
		dateOfBirth: '',
		phoneNumber: user?.contact_number || '',
		emailAddress: user?.email_address || '',
		addressLine1: user?.address_line_1 || '',
		addressLine2: user?.address_line_2 || '',
		city: user?.city || '',
		postcode: user?.postcode || '',
		selectedService: null,
	});

	const transformBusinessPartnerTests = (tests) =>
		tests.map((test) => ({
			service: {
				appt_duration: '15',
				appt_stackable: 'true',
				email_template: 'testOnlyPurchase',
				enable_discount: test.enable_discount,
				is_private: false,
				service_bookable: true,
				service_code: test.sirkka_test_identifier.toLowerCase().replace(/-/g, ''),
				service_id: test.test_id,
				service_name: test.test_name,
				tdl_lab_code: test.tdl_lab_code
					? test.tdl_lab_code.split(',').map((code) => code.trim())
					: [],
				service_price: test.test_price,
				service_status: test.status.toString(),
				service_type: 'Postal',
			},
		}));

	const services =
		businessPartnerTests && businessPartnerTests.length > 0
			? transformBusinessPartnerTests(businessPartnerTests)
			: testOnlyProducts;

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData((prev) => ({ ...prev, [name]: value }));
	};

	const handleServiceChange = (e) => {
		const selectedServiceId = e.target.value;
		const foundService = services.find(
			(svc) => svc.service.service_id.toString() === selectedServiceId
		);
		setFormData((prev) => ({
			...prev,
			selectedService: foundService,
		}));
	};

	const handleSubmit = () => {
		const missingFields = Object.entries(formData)
			.filter(
				([key, value]) =>
					[
						'firstName',
						'lastName',
						'gender',
						'dateOfBirth',
						'addressLine1',
						'emailAddress',
						'selectedService',
					].includes(key) && !value
			)
			.map(([key, _]) => key);

		if (missingFields.length > 0) {
			alert(`Please fill in the required fields`);
			return;
		}

		const newBooking = {
			booking: {
				bookingId: Date.now().toString(),
				locationId: 5,
				bookingName: `${formData.firstName} ${formData.lastName}`,
				bookingProduct: formData.selectedService.service.service_name,
				appointmentLocation: 'Postal',
				appointmentRegion: 'Postal',
				appointmentDate: formData.selectedDate || 'N/a',
				appointmentTime: formData.selectedTime || 'N/a',
				appointmentNotes: '',
				appointmentFor: 'patient',
				sampleConsent: true,
				termsconditions: true,
				completed: true,
			},
			customer: {
				nameTitle: '',
				firstName: formData.firstName,
				lastName: formData.lastName,
				emailAddress: formData.emailAddress || 'Not provided',
				gender: formData.gender,
				dateOfBirth: formData.dateOfBirth,
				phoneNumber: formData.phoneNumber,
				company: '',
				occupation: '',
			},
			postal: {
				postageAddressLine1: formData.addressLine1,
				postageAddressLine2: formData.addressLine2 || '',
				postageCity: formData.city,
				postagePostcode: formData.postcode,
				postageCountry: 'United Kingdom',
			},
			service: {
				serviceName: formData.selectedService.service.service_name,
				serviceId: formData.selectedService.service.service_code,
				serviceType: formData.selectedService.service.service_type,
				emailTemplate: formData.selectedService.service.email_template,
				tdlLabCode: formData.selectedService.service.tdl_lab_code || null,
				regionId: 4,
				price: formData.selectedService.service.service_price,
			},
			entity: {
				entityId: user?.user_id || null,
				entityName: user?.company || null,
			},
			source: 'Business_Partner_Booking',
		};

		setBookingData((prev) => [...prev, newBooking]);
		onContinue();
	};

	if (!services) return null;

	return (
		<>
			<h3 className="mt-5">Patient Details</h3>
			<p>(We will use these details to register with the lab)</p>
			<div>
				<div className="row">
					<div className="col">
						<label>
							First Name <span>*</span>
						</label>
						<input
							required
							type="text"
							name="firstName"
							value={formData.firstName}
							onChange={handleChange}
						/>
					</div>
					<div className="col">
						<label>
							Last Name <span>*</span>
						</label>
						<input
							required
							type="text"
							name="lastName"
							value={formData.lastName}
							onChange={handleChange}
						/>
					</div>
				</div>

				<div className="row">
					<div className="col">
						<label>
							Gender <span>*</span>
						</label>
						<select required name="gender" value={formData.gender} onChange={handleChange}>
							<option value="" disabled>
								Select Gender
							</option>
							<option value="Male">Male</option>
							<option value="Female">Female</option>
							<option value="Other">Other</option>
						</select>
					</div>
					<div className="col">
						<label>
							Date of Birth <span>*</span>
						</label>
						<input
							required
							type="date"
							name="dateOfBirth"
							value={formData.dateOfBirth}
							onChange={handleChange}
						/>
					</div>
				</div>
			</div>
			<h3 className="mt-5">Select products</h3>
			<div>
				<select
					className="mt-3 mb-3"
					required
					name="serviceId"
					value={formData.selectedService?.service?.service_id || ''}
					onChange={handleServiceChange}
				>
					<option value="" disabled>
						Select service
					</option>
					{services
						.filter(
							(service) =>
								service.service.service_status === 'true' &&
								service.service.service_bookable === true
						)
						.map((service, index) => (
							<option key={index} value={service.service.service_id}>
								{service.service.service_name}
							</option>
						))}
				</select>
				<div style={{ marginTop: '20px' }}>
					<button className="primary_btn" onClick={handleSubmit}>
						Proceed to purchase
					</button>
				</div>
			</div>
		</>
	);
};

export default SelectTestOnly;
